import React, { useEffect, useRef } from "react";
import SEO from "components/SEO/SEO";
import "./ChannelPartners.css";
import kb   from "assets/partners/kotak.png";
import idfc from "assets/partners/idfc.png";
import rbl  from "assets/partners/rbl.png";
import yb   from "assets/partners/yes bank.png";
import hr   from "assets/partners/hero.png";
import lt   from "assets/partners/l&t.png";
import knr  from "assets/partners/kinara.png";
import prf  from "assets/partners/piramal.png";
import oc   from "assets/partners/onecard.png";
import hc   from "assets/partners/homecredit.png";
import krb  from "assets/partners/kreditbee.png";
import slc  from "assets/partners/slice.png";
import mbk  from "assets/partners/mobikwik.png";
import mv   from "assets/partners/moneyview.png";
import ax   from "assets/partners/axio.png";
import irc  from "assets/partners/iarc.png";
import ifl  from "assets/partners/iifl.png";
//import bnb  from "assets/partners/bandan.jpg";
import tyg  from "assets/partners/tyger.jpg";
import tvs  from "assets/partners/tvs.png";
import smfg from "assets/partners/smfg.png";


const RBI_SACHET = "https://sachet.rbi.org.in/";

const CATEGORIES = [
  {
    label: "Banking Sector",
    icon: "🏦",
    partners: [
      { name: "Kotak Mahindra Bank", logo: kb,   website: "https://www.kotak.com" },
      { name: "IDFC First Bank",     logo: idfc,  website: "https://www.idfcfirstbank.com" },
      { name: "RBL Bank",            logo: rbl,   website: "https://www.rblbank.com" },
      { name: "Yes Bank",            logo: yb,    website: "https://www.yesbank.in" },
      //{ name: "Bandhan Bank",        logo: bnb,   website: "https://www.bandhanbank.com" },
      { name: "IIFL Finance",        logo: ifl,   website: "https://www.iifl.com" },
      { name: "Slice",      logo: slc, website: "https://www.sliceit.com" },
    ],
  },
  {
    label: "NBFCs",
    icon: "🏢",
    partners: [
      { name: "Tyger Capital",     logo: tyg,  website: "https://www.tygercapital.in" },
      { name: "TVS Credit",        logo: tvs,  website: "https://www.tvscredit.com" },
      { name: "Hero Fincorp",      logo: hr,   website: "https://www.herofincorp.com" },
      { name: "L&T Finance",       logo: lt,   website: "https://www.ltfinance.com" },
      { name: "Kinara Capital",    logo: knr,  website: "https://www.kinaracapital.com" },
      { name: "Piramal Finance",   logo: prf,  website: "https://www.piramalfinance.com" },
      { name: "Home Credit India", logo: hc,   website: "https://www.homecredit.co.in" },
      { name: "SMFG India Credit", logo: smfg, website: "https://www.smfgindiacredit.com" },
    ],
  },
  {
    label: "Fintechs & ARCs",
    icon: "💡",
    partners: [
      { name: "One Card",    logo: oc,  website: "https://www.getonecard.app" },
      { name: "KreditBee",  logo: krb, website: "https://www.kreditbee.in" },
      { name: "MobiKwik",   logo: mbk, website: "https://www.mobikwik.com" },
      { name: "MoneyView",  logo: mv,  website: "https://www.moneyview.in" },
      { name: "Axio",       logo: ax,  website: "https://www.axio.credit" },
      { name: "IARC",       logo: irc, website: "https://www.iarcindia.com" },
    ],
  },
];

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const cards = el.querySelectorAll(".cp-card");
    const io = new IntersectionObserver(
      (entries) => entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add("revealed"); io.unobserve(e.target); }
      }),
      { rootMargin: "0px 0px -50px 0px", threshold: 0.1 }
    );
    cards.forEach(card => io.observe(card));
    return () => io.disconnect();
  }, []);
  return ref;
}

export default function ChannelPartners() {
  const sectionRef = useReveal();
  const totalPartners = CATEGORIES.reduce((acc, cat) => acc + cat.partners.length, 0);

  return (
    <>
      <SEO
        title="Channel Partners | CSR Associates — Trusted by India's Top Banks & NBFCs"
        description="CSR Associates is trusted by 20+ leading financial institutions including Kotak Mahindra Bank, IDFC First Bank, RBL Bank, Hero Fincorp for professional debt recovery."
        keywords="CSR Associates partners, Kotak debt recovery, IDFC collections, RBL bank recovery, NBFC collections agency, fintech collections Bangalore"
      />


      <div className="cp-page" ref={sectionRef}>
        <div className="container" style={{ maxWidth: 1200, margin: "0 auto", padding: "80px 24px" }}>

          {/* Hero */}
          <div className="page-hero" data-aos="fade-up">
            <span className="page-hero-tag">Our Network</span>
            <h1 className="page-hero-title">
              A Portfolio of <em>Trust</em>
            </h1>
            <p className="page-hero-sub">
              Proud to serve India's leading banks, NBFCs, and fintechs.
              Every partnership built on consistent results and ethical operations.
            </p>
            <div className="page-hero-divider" />
          </div>

          {/* Stats row */}
          <div className="cp-stats" data-aos="fade-up">
            {[
              { num: `${totalPartners}+`, label: "Active Partners" },
              { num: "3", label: "Sectors Covered" },
              { num: "12+", label: "Years of Trust" },
              { num: "500+", label: "Clients Served" },
            ].map((s, i) => (
              <div key={i} className="cp-stat-item">
                <span className="cp-stat-num">{s.num}</span>
                <span className="cp-stat-label">{s.label}</span>
              </div>
            ))}
          </div>

          {/* Categories */}
          {CATEGORIES.map((cat) => (
            <div key={cat.label} className="cp-category">
              <div className="cp-category-header" data-aos="fade-right">
                <span className="cp-cat-icon">{cat.icon}</span>
                <div>
                  <div className="eyebrow" style={{ marginBottom: 4 }}>{cat.label}</div>
                  <div className="cp-cat-count">{cat.partners.length} Partners</div>
                </div>
              </div>

              <div className="cp-grid">
                {cat.partners.map((partner, i) => (
                  <div
                    key={partner.name}
                    className="cp-card"
                    style={{ transitionDelay: `${i * 50}ms` }}
                  >
                    <div className="cp-card-logo-wrap">
                      <img src={partner.logo} alt={`${partner.name} — CSR Associates partner`} loading="lazy" />
                    </div>
                    <div className="cp-card-name">{partner.name}</div>
                    <div className="cp-card-links">
                      <a href={partner.website} target="_blank" rel="noopener noreferrer"
                        className="cp-link cp-link--site" title={`Visit ${partner.name}`}>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                          <circle cx="12" cy="12" r="10"/>
                          <line x1="2" y1="12" x2="22" y2="12"/>
                          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                        </svg>
                        Website
                      </a>
                      <a href={RBI_SACHET} target="_blank" rel="noopener noreferrer"
                        className="cp-link cp-link--sachet" title="RBI Sachet Grievance Portal">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                        </svg>
                        RBI Sachet
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* RBI Sachet notice */}
          <div className="cp-sachet-notice" data-aos="fade-up">
            <div className="cp-sachet-icon">🏛️</div>
            <div>
              <strong>Grievance Redressal</strong>
              <p>
                To raise a complaint against any financial service provider,
                visit the official RBI Sachet Portal.{" "}
                <a href={RBI_SACHET} target="_blank" rel="noopener noreferrer">
                  sachet.rbi.org.in →
                </a>
              </p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
